import { Flex } from '@sequencehq/core-components'
import { RevRecDashboardTable } from './RevRecDashboardTable'

export const RevenueRecognitionDashboardContent = () => {
  return (
    <Flex flexDirection="column" height="100%">
      <RevRecDashboardTable />
    </Flex>
  )
}
